import AdComponent from "./AdComponent";

export default AdComponent;
